import type { ErrorContext, Severity, RecoveryIntent } from '../types.js';
import { X402ErrorCodes } from './error-codes.js';
import { sanitizeCode, validateSeverity } from '../utils/normalize.js';
import type { ParsedX402Error } from './parser.js';

export function mapToErrorContext(parsed: ParsedX402Error): ErrorContext {
  const { code, message, severity, raw } = parsed;
  
  // Sanitize the code
  const sanitizedCode = code ? sanitizeCode(code) : undefined;
  
  // Find matching canonical error or use unknown
  let errorDef;
  if (sanitizedCode) {
    for (const [, value] of Object.entries(X402ErrorCodes)) {
      if (value.code === sanitizedCode) {
        errorDef = value;
        break;
      }
    }
  }
  
  // Use unknown error if no match found
  if (!errorDef) {
    errorDef = X402ErrorCodes.UNKNOWN_402;
  }
  
  // Override with parsed values if provided
  const finalSeverity = severity ? validateSeverity(severity) : errorDef.severity;
  const finalMessage = message || errorDef.message;
  
  return {
    code: errorDef.code,
    message: finalMessage,
    severity: finalSeverity as Severity,
    recoveryIntent: errorDef.recovery as RecoveryIntent,
    raw
  };
}